// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__AwovX","overflowing":"ReadFullNote_overflowing__33gRu"};